export const NETFLIX_MERCHANT_ID_HARD = 1;
export const WAVVE_MERCHANT_ID_HARD = 2;
export const WATCHA_MERCHANT_ID_HARD = 3;
export const LAFTEL_MERCHANT_ID_HARD = 4;
export const SINGLE_MERCHANDISE_ID_HARD = 14;
export const DEFAULT_SELECTED_MERCHANT_ID_HARD = 1;
export const MAX_SLOT_COUNT_HARD = 4;
export const SELECTED_MERCHANT = "selected_merchant";
export const SELECTED_USER_TYPE = "selected_user_type";
